<template>
  <div class="hero">
    <div class="container">
      <div class="row">
        <div class="col-md-6 text-hero">
          <h1>Sessions</h1>
          <p>
            SESSIONS empowers caregivers, professionals, and individuals impacted by dementia to connect, learn, and support each other.
          </p>
        </div>
        <div class="col-md-6 img-hero">
          <img src="@/assets/img/sessions/hero.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sessions_Hero"
};
</script>

<style lang="scss" scoped>
.hero {
  min-height: 452px;
  background-image: url("../../../assets/img/sessions/hero-bg.svg");
  background-repeat: no-repeat;
  background-size: cover;
  //background-color: #F7FAFD;
  .container {
    .text-hero {
      min-height: 452px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      h1 {
        font-style: normal;
        font-weight: 800;
        font-size: 96px;
        line-height: 131px;
        color: #557efb;
        margin-bottom: 16px;
      }
      p {
        font-style: normal;
        font-weight: 600;
        font-size: 19px;
        line-height: 26px;
        color: #474d52;
        margin-bottom: 16px;
      }
      .btn {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        letter-spacing: 0.1em;
        text-transform: capitalize;
      }
    }
    .img-hero {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
      }
    }
  }
}
@media (max-width: 650px) {
  .hero {
    .text-hero {
      h1 {
        font-size: 60px !important;
        line-height: 70px !important;
      }
    }
  }
}
</style>
